import React from "react";
import { Accordion } from "@mantine/core";
import CollapsibleItem from "./CollapsibleItem";

function JobDetailsAccordion({
  aboutMtn,
  mission,
  keyPerformanceAreas,
  experience,
  educationBackground,
  applyInstructions,
}) {
  return (
    <Accordion
      variant="separated"
      multiple
      transitionDuration={150}
      className="w-full font-MTNfont"
      classNames={{
        // trim all vertical margins between items
        item: "my-1",
        control: "py-1.5 px-3 text-sm leading-5 min-h-0",
        label: "text-sm",
        chevron: "scale-90",
        panel: "py-2 px-3",
      }}
    >
      <CollapsibleItem label="About MTN">{aboutMtn}</CollapsibleItem>
      <CollapsibleItem label="Mission/Core purpose of the Job">{mission}</CollapsibleItem>
      <CollapsibleItem label="Key Performance Areas">{keyPerformanceAreas}</CollapsibleItem>
      <CollapsibleItem label="Experience">{experience}</CollapsibleItem>
      <CollapsibleItem label="Education Background">{educationBackground}</CollapsibleItem>
      <CollapsibleItem label="How To Apply">{applyInstructions}</CollapsibleItem>
    </Accordion>
  );
}

export default JobDetailsAccordion;
